module.exports = __webpack_public_path__ + "static/media/facebook-2429746_1280.d1ddbb0b.png";